"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtChat = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtChat = function SvgBtChat(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.324 20.759l.199-.46a.5.5 0 00-.36-.014l.161.474zm-4.65-.19l-.326-.379a.5.5 0 00.181.859l.144-.48zm2.023-1.734l.326.38a.5.5 0 00.053-.706l-.379.326zm5.646 3.042c4.262 0 7.766-3.27 7.766-7.362h-1c0 3.487-3.002 6.362-6.766 6.362v1zm-3.217-.66c.981.425 2.071.66 3.217.66v-1a7.1 7.1 0 01-2.82-.577l-.397.918zm-4.597-.168c.564.169 1.392.348 2.275.421.876.073 1.85.044 2.681-.238l-.321-.947c-.644.22-1.463.256-2.277.189a10.62 10.62 0 01-2.07-.383l-.288.958zm1.843-2.594L6.348 20.19l.65.76 2.025-1.735-.651-.76zm-1.795-3.94c0 1.764.655 3.381 1.74 4.646l.76-.652a6.104 6.104 0 01-1.5-3.994h-1zm7.766-7.363c-4.262 0-7.766 3.27-7.766 7.363h1c0-3.488 3.002-6.363 6.766-6.363v-1zm7.766 7.363c0-4.093-3.504-7.363-7.766-7.363v1c3.764 0 6.766 2.876 6.766 6.363h1zm-10.76-1.212c0-.26.21-.47.47-.47v-1a1.47 1.47 0 00-1.47 1.47h1zm.47.47a.47.47 0 01-.47-.47h-1c0 .811.658 1.47 1.47 1.47v-1zm3.393 0h-3.394v1h3.394v-1zm.47-.47c0 .26-.21.47-.47.47v1a1.47 1.47 0 001.47-1.47h-1zm-.47-.47c.26 0 .47.21.47.47h1a1.47 1.47 0 00-1.47-1.47v1zm-3.394 0h3.394v-1h-3.394v1z",
    fill: "currentColor"
  }));
};

exports.SvgBtChat = SvgBtChat;